import { fetchPageState } from '../../utilities/fetch-api';

export async function loginLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/login/state', request, {
    capabilities: ['capability-group--login'],
  });
}
